import { createContext } from 'react';

export const HistogramLoadingContext = createContext<boolean | undefined>(
  undefined,
);

HistogramLoadingContext['displayName'] = 'HistogramLoadingContext';
